/* Darling Lux — product page upgrade (sofija theme) */
(() => {
  if (window.__dlxPdp) return;
  window.__dlxPdp = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function moneyFormat() {
    const el = document.querySelector('[data-dlx-money-format]');
    return (el && el.getAttribute('data-dlx-money-format')) || '€{{amount_with_comma_separator}}';
  }

  function formatMoney(cents) {
    const n = Number(cents) / 100;
    const fmt = moneyFormat();
    const withSep = (dec, thou) => {
      const [i, d] = n.toFixed(2).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + dec + d;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_with_comma_separator': return withSep(',', '.');
        case 'amount_no_decimals': return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_no_decimals_with_comma_separator': return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_with_apostrophe_separator': return withSep('.', "'");
        default: return withSep('.', ',');
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  async function addItems(items, btn, msgEl) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (msgEl) msgEl.textContent = '';
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      const cart = await (await fetch(root + 'cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'dlx-pdp', data: { source: 'dlx-pdp', itemCount: cart.item_count, sections: {} } },
      }));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        if (!drawer.hasAttribute('auto-open')) drawer.open();
      } else {
        window.location.href = root + 'cart';
      }
    } catch (err) {
      if (msgEl) msgEl.textContent = err.message;
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  }

  /* Re-render dlx blocks with fresh HTML when the variant changes */
  document.addEventListener('variant:update', (e) => {
    const html = e.detail && e.detail.data && e.detail.data.html;
    if (!html || !html.querySelector) return;
    document.querySelectorAll('[data-dlx-refresh][id]').forEach((el) => {
      const fresh = html.querySelector('#' + CSS.escape(el.id));
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
    initCompleteLook();
    initSticky();
  });

  /* Bundle */
  function updateBundle(box) {
    const inner = box.querySelector('[data-dlx-bundle-inner]');
    if (!inner) return;
    const pct = Number(inner.dataset.pct || 0);
    const main = Number(inner.dataset.mainPrice || 0);
    const sel = inner.querySelector('[data-dlx-bundle-partner]');
    const opt = sel && sel.tagName === 'SELECT' ? sel.selectedOptions[0] : sel;
    if (!opt) return;
    const partner = Number(opt.dataset.price || 0);
    const total = main + partner;
    const disc = Math.round(total * (100 - pct) / 100);
    const was = inner.querySelector('[data-dlx-bundle-was]');
    const now = inner.querySelector('[data-dlx-bundle-now]');
    if (was) was.textContent = formatMoney(total);
    if (now) now.textContent = formatMoney(disc);
    const thumb = inner.querySelector('[data-dlx-bundle-thumb]');
    if (thumb && opt.dataset.img) { thumb.src = opt.dataset.img; thumb.alt = opt.dataset.title || ''; }
  }

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-dlx-bundle-partner]');
    if (sel) updateBundle(sel.closest('[data-dlx-bundle]'));
  });

  document.addEventListener('click', (e) => {
    const bundleBtn = e.target.closest('[data-dlx-bundle-add]');
    if (bundleBtn) {
      const inner = bundleBtn.closest('[data-dlx-bundle-inner]');
      const sel = inner.querySelector('[data-dlx-bundle-partner]');
      const opt = sel && sel.tagName === 'SELECT' ? sel.selectedOptions[0] : sel;
      const mainId = inner.dataset.mainVariant;
      const partnerId = opt && opt.dataset.variant;
      if (!mainId || !partnerId) return;
      addItems([{ id: Number(mainId), quantity: 1 }, { id: Number(partnerId), quantity: 1 }], bundleBtn, inner.querySelector('.dlx-msg'));
      return;
    }

    const cardBtn = e.target.closest('[data-dlx-add-variant]');
    if (cardBtn) {
      e.preventDefault();
      const box = cardBtn.closest('[data-dlx-ctl]');
      addItems([{ id: Number(cardBtn.dataset.dlxAddVariant), quantity: 1 }], cardBtn, box && box.querySelector('.dlx-msg'));
      return;
    }

    const ugcBtn = e.target.closest('[data-dlx-ugc-open]');
    if (ugcBtn) {
      const section = ugcBtn.closest('[data-dlx-ugc]');
      const dialog = section && section.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const media = dialog.querySelector('[data-dlx-ugc-media]');
      const link = dialog.querySelector('[data-dlx-ugc-link]');
      const handle = dialog.querySelector('[data-dlx-ugc-handle]');
      const src = ugcBtn.querySelector('img, video');
      media.innerHTML = '';
      if (src) {
        const clone = src.cloneNode(true);
        if (clone.tagName === 'VIDEO') { clone.controls = true; clone.muted = false; clone.autoplay = true; clone.loop = false; clone.removeAttribute('preload'); }
        if (clone.tagName === 'IMG' && ugcBtn.dataset.full) { clone.src = ugcBtn.dataset.full; clone.removeAttribute('srcset'); }
        media.appendChild(clone);
      }
      handle.textContent = ugcBtn.dataset.handle || '';
      if (ugcBtn.dataset.url) { link.href = ugcBtn.dataset.url; link.hidden = false; } else { link.hidden = true; }
      dialog.showModal();
      return;
    }

    const ugcClose = e.target.closest('[data-dlx-ugc-close]');
    if (ugcClose) { ugcClose.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('dlx-ugc__dialog')) e.target.close();
  });

  document.addEventListener('close', (e) => {
    if (e.target.classList && e.target.classList.contains('dlx-ugc__dialog')) {
      const v = e.target.querySelector('video');
      if (v) v.pause();
    }
  }, true);

  /* Complete the look — fetch recommendations when no curated list exists */
  function cardHtml(p, labels) {
    const variant = (p.variants || []).find((v) => v.available);
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const imgUrl = img ? (typeof img === 'string' ? img : img.src) : '';
    const sized = imgUrl ? imgUrl + (imgUrl.includes('?') ? '&' : '?') + 'width=400' : '';
    const single = variant && p.variants.length === 1;
    const action = single
      ? `<button type="button" class="dlx-ctl-card__btn" data-dlx-add-variant="${variant.id}">${escapeHtml(labels.add)}</button>`
      : `<a class="dlx-ctl-card__btn" href="${escapeHtml(p.url)}">${escapeHtml(variant ? labels.choose : labels.soldout)}</a>`;
    return `<div class="dlx-ctl-card">
      <a class="dlx-ctl-card__media" href="${escapeHtml(p.url)}" tabindex="-1" aria-hidden="true">${sized ? `<img src="${escapeHtml(sized)}" alt="" loading="lazy" width="400" height="300">` : ''}</a>
      <a class="dlx-ctl-card__title" href="${escapeHtml(p.url)}" title="${escapeHtml(p.title)}">${escapeHtml(p.title)}</a>
      <span class="dlx-ctl-card__price">${formatMoney(p.price)}</span>
      ${action}
    </div>`;
  }

  async function fetchRecs(productId, limit, intent) {
    const r = await fetch(`${root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`);
    if (!r.ok) return [];
    const j = await r.json();
    return j.products || [];
  }

  async function initCompleteLook() {
    const boxes = document.querySelectorAll('[data-dlx-ctl][data-needs-fetch]:not([data-loaded])');
    for (const box of boxes) {
      box.setAttribute('data-loaded', '');
      const id = box.dataset.productId;
      const limit = Number(box.dataset.limit || 2);
      const labels = { add: box.dataset.labelAdd || 'Add to cart', choose: box.dataset.labelChoose || 'Choose', soldout: box.dataset.labelSoldout || 'Sold out' };
      try {
        let products = await fetchRecs(id, limit, 'complementary');
        if (!products.length) products = await fetchRecs(id, limit, 'related');
        products = products.slice(0, limit);
        if (!products.length) { box.hidden = true; continue; }
        box.querySelector('[data-dlx-ctl-grid]').innerHTML = products.map((p) => cardHtml(p, labels)).join('');
        box.hidden = false;
      } catch (_) {
        box.hidden = true;
      }
    }
  }

  /* Sticky add to cart */
  function initSticky() {
    document.querySelectorAll('[data-dlx-sticky]:not([data-ready])').forEach((bar) => {
      bar.setAttribute('data-ready', '');
      const scope = bar.closest('.product-information') || document;
      const mainBtn = scope.querySelector('.product-details button[name="add"]');
      if (!mainBtn || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
      io.observe(mainBtn);
      bar.querySelector('[data-dlx-sticky-btn]').addEventListener('click', () => {
        const btn = scope.querySelector('.product-details button[name="add"]');
        if (btn) btn.click();
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-dlx-bundle]').forEach(updateBundle);
    initCompleteLook();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
